import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=ab5d7fdc&scoped=true&"
import script from "./DetailHeader.vue?vue&type=script&lang=ts&"
export * from "./DetailHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DetailHeader.vue?vue&type=style&index=0&id=ab5d7fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5d7fdc",
  null
  
)

export default component.exports